import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import * as VeeValidate from 'vee-validate'
import cookie from 'js-cookie'
import VueClipboard from 'vue-clipboard2'
import DatetimePicker from 'vuetify-datetime-picker'
import './scss/main.scss'
import moment from 'moment'

// Validator
Vue.use(VeeValidate)
// Clipboard
Vue.use(VueClipboard)
// Vuetify Datetime picker
Vue.use(DatetimePicker)

Vue.config.productionTip = false
Vue.prototype.moment = moment

store.dispatch('attempt', cookie.get('access_token')).then(() => {
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app')
})
